<template>
  <div class="horizontal-scroll-window-wrapper">
    <h4>{{ title }}</h4>
    <div class="scroll-window">
      <div class="scroll-padding"></div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: {},
  props: ["title"],
};
</script>
<style scoped>
h4 {
  text-align: left;
}
.scroll-window {
  display: flex;
  width: 100%;
  overflow-x: scroll;
}

.scroll-padding {
  min-width: 20px;
  height: 100%;
}
</style>
